import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getIdsByBitMask } from '../../../pages/Team/Team';
import { getColor } from '../../../utils/helper';
import Ava from '../Ava/Ava';
import './UserBanner.scss';
import { Account_Info } from '../../../generated/mlmbox/types/account';

export interface IUserBanner extends Account_Info {
    handleClick?: Function;
}

const UserBanner: FC<IUserBanner> = ({ channels, account, profile, treeIdsBitMask, handleClick, relationship }) => {
    const { t } = useTranslation();

    function click() {
        if (handleClick) handleClick();
    }

    function getName(): string {
        if (channels.includes(1)) {
            if (profile?.firstName.length === 0 && profile?.lastName.length === 0) return t('unknown_duck');
            return `${profile?.firstName} ${' '} ${profile?.lastName}`;
        }

        if (profile?.telegram?.username) return `${profile.telegram.username}`;

        if (channels.includes(2) || channels.includes(3)) return t('unknown_duck');

        return '';
    }

    return (
        <div
            className="user-banner"
            onClick={click}>
            <Ava
                width="40px"
                height="40px"
                collectionId={profile?.ava?.collectionId}
                entityId={profile?.ava?.entityId}
                borderColor={getColor(relationship)}
            />
            <div className="text">
                <h3>{getName()}</h3>
                <p>
                    {account?.login && (
                        <>
                            @{account?.login}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="2"
                                height="12"
                                viewBox="0 0 2 12"
                                fill="none">
                                <path
                                    d="M1 0V12"
                                    stroke="#506690"
                                />
                            </svg>
                        </>
                    )}
                    {getIdsByBitMask(treeIdsBitMask, channels)}
                </p>
            </div>
        </div>
    );
};

export default UserBanner;
